<template>
  <div id="app">
    <!-- <router-view></router-view> -->

    <keep-alive >
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {

    },
    mounted() {
      var h = document.documentElement.clientWidth / 7.5 + 'px';
      document.documentElement.style.fontSize = h;


    }
  }
</script>

<style lang="less">
  @import "~@/assets/all.less";

  .dayu {
    width: 750px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue